<div *ngIf="relatedArticles?.length > 0">
  <div
    *ngIf="!companyName || requestedEntities?.length > 1"
    class="article__title"
  >
    Articles
  </div>
  <div
    *ngIf="
      companyName && companyName !== 'all' && requestedEntities?.length === 1
    "
    class="article__title"
  >
    Articles about
    <a
      class="article__entity"
      (click)="navigateToArticleCompany(companyName, companyType)"
    >
      {{ entitiyName }}
    </a>
  </div>

  <div class="article__cards" [ngClass]="{ wider: !chartVisible }">
    <app-article-card
      *ngFor="let article of relatedArticles"
      [title]="article.title"
      [publishTime]="article.publish_time"
      [provider]="article.provider"
      [eventNames]="article?.eventNames"
      [entityNames]="article?.entityNames"
      [citation]="article?.citation"
      (click)="triggerArticleView(companyName, companyType, article)"
    >
    </app-article-card>
  </div>
</div>
